import logo from "../../assets/images/ejjadh-logo.png";

const Footer = () => {
	return (
		<footer>
			<p>
				تطوير
				<a href="https://nsn.sa/" target="_blank" rel="noreferrer">
					<img src={logo} alt="Ejjadh" />
				</a>
			كل الحقوق محفوظه
			</p>
		</footer>
	);
};

export default Footer;
